import monitor from '@blaze-cms/plugin-monitor';
import serverMonitors from '@blaze-cms/plugin-monitor/src/server-monitors';
import sentry from '@blaze-cms/plugin-sentry/src/utils/browser';
import coreAdminPlugin from '@blaze-cms/plugin-admin-core-ui';
import example from './src/blaze-plugins/example';
import content from './src/blaze-plugins/content';
import YachtIcon from './src/icons/YachtIcon';

export default function buildConfig(config) {
  serverMonitors('admin', [sentry]);

  config.plugins.set(coreAdminPlugin, {
    menuConfig: {
      main: {
        items: {
          superports: {
            order: 12,
            label: 'Superports',
            icon: YachtIcon,
            items: {}
          }
        }
      }
    }
  });

  config.plugins.set(monitor, {});
  config.plugins.set(example, {});
  config.plugins.set(content, {});
  return config;
}
